import React, { useEffect, useState, useRef } from 'react';
import ProjectCard from '../components/ui/ProjectCard';
// Sample project data with swapped categories
const projectsData = [{
  id: '1',
  title: 'Duplex (Oguweuyi Site, Edo State)',
  category: 'Interior',
  description: 'A modern duplex featuring elegant design, premium finishes, and contemporary living spaces with custom interior elements and high-quality construction.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/doJtysMZ2cn8UzmYHd2dV1/WhatsApp_Image_2025-09-25_at_20.11.14_a91cca1b.jpg',
  location: 'Oguweuyi, Edo State',
  completionDate: '2023'
}, {
  id: '2',
  title: 'Duplex (Warri site, Delta State)',
  category: 'Construction',
  description: 'Luxury residential duplex with sophisticated architectural details, spacious interiors, and premium fixtures designed for comfort and elegance.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pHY9Tt8e25nnUbvQbNh3Lp/WhatsApp_Image_2025-09-25_at_20.06.19_64d0896c.jpg',
  location: 'Warri, Delta State',
  completionDate: '2023'
}, {
  id: '3',
  title: 'Modern Interior Design',
  category: 'Construction',
  description: 'Contemporary interior design featuring premium finishes, custom cabinetry, and elegant lighting solutions for a luxurious living experience.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k61KSdMC5Ph7NbRvwSFeyc/WhatsApp_Image_2025-09-25_at_20.11.14_5943a238.jpg',
  location: 'Edo State',
  completionDate: '2023'
}, {
  id: '4',
  title: 'Custom Kitchen Design',
  category: 'Interior',
  description: 'Modern kitchen featuring sleek cabinetry, premium appliances, and elegant marble countertops with integrated lighting and functional design.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1oA8SucVPZELRBKDqSH2oY/WhatsApp_Image_2025-09-25_at_20.11.14_66401783.jpg',
  location: 'Edo State',
  completionDate: '2023'
}, {
  id: '5',
  title: '3 Bedroom Bungalow with Boys Quarters',
  category: 'Construction',
  description: 'Complete 3 bedroom bungalow with boys quarters, security house and bush bar on 513sqm land. Designed, built and furnished for a treasured client in Queens Estate Abuja.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n3SWYVzCoAQQL8PbFMACNe/50626243_2025547797565354_2083584211196837888_n.jpg',
  location: 'Queens Estate, Abuja',
  completionDate: '2019'
}, {
  id: '6',
  title: 'Ebo Primary School',
  category: 'Construction',
  description: 'Complete construction of a modern primary school facility featuring multiple classrooms with contemporary finishes, proper ventilation, and durable infrastructure designed for optimal learning environment.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c2zT4vMMpETDDHVZvcitzy/Outside_view.jpg',
  location: 'Edo State',
  completionDate: '2024'
}, {
  id: '7',
  title: 'Ayen Market',
  category: 'Construction',
  description: 'Commercial market facility construction featuring multiple vendor stalls with durable concrete foundations, plastered walls, quality flooring, and comprehensive metal roofing structure designed for commercial trading activities.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Dzng3JSWzcQbA3b6EfNkK/WhatsApp_Image_2025-10-31_at_10.16.50_ab9be3ee.jpg',
  location: 'Edo State',
  completionDate: '2024'
}, {
  id: '8',
  title: 'Market at Iguezomo',
  category: 'Construction',
  description: 'Reconstruction and renovation of Iguezomo Market featuring durable concrete foundations, vibrant red painted stalls, quality flooring, and comprehensive metal roofing structure designed for enhanced commercial trading activities.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fbiJWPJDW5fUNm6kA1idEx/WhatsApp_Image_2025-10-31_at_09.52.44_ba3b8656.jpg',
  location: 'Iguezomo, Edo State',
  completionDate: '2024'
}, {
  id: '9',
  title: 'Edha Solar Street Lighting Project',
  category: 'Construction',
  description: 'Comprehensive solar-powered street lighting infrastructure project featuring foundation work, electrical installations, and modern LED street lights designed to enhance community safety and visibility.',
  imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eQ1CF7mhB4Y1YCGqV9U47K/WhatsApp_Image_2025-10-31_at_09.54.59_d118ae88.jpg',
  location: 'Edha, Edo State',
  completionDate: '2024'
}];
const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [animatedProjects, setAnimatedProjects] = useState<string[]>([]);
  const projectsRef = useRef(null);
  const filters = ['All', 'Construction', 'Interior'];
  const filteredProjects = activeFilter === 'All' ? projectsData : projectsData.filter(project => project.category === activeFilter);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setTimeout(() => {
          const newAnimated = [];
          for (let i = 0; i < projectsData.length; i++) {
            setTimeout(() => {
              newAnimated.push(projectsData[i].id);
              setAnimatedProjects([...newAnimated]);
            }, i * 200);
          }
        }, 300);
        observer.unobserve(entries[0].target);
      }
    }, {
      threshold: 0.1
    });
    if (projectsRef.current) {
      observer.observe(projectsRef.current);
    }
    return () => {
      if (projectsRef.current) {
        observer.unobserve(projectsRef.current);
      }
    };
  }, []);
  return <div className="w-full pt-20" data-id="element-649">
      {/* Hero Section */}
      <section className="relative py-20 bg-gray-900" data-id="element-650">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-651">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ksFwscNdhK6ddZHmFijTWo/image_.jpg" alt="Project portfolio" className="w-full h-full object-cover" data-id="element-652" />
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-653">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-fadeInDown" data-id="element-654">
            Our Projects
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto animate-fadeInUp" data-id="element-655">
            Explore our portfolio of successful projects across various sectors
          </p>
        </div>
      </section>
      {/* Projects Grid */}
      <section className="py-20" data-id="element-656">
        <div className="container mx-auto px-4 md:px-6" data-id="element-657">
          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center mb-12 animate-fadeIn" data-id="element-658">
            <div className="bg-gray-100 rounded-full p-1 inline-flex mb-4 md:mb-0" data-id="element-659">
              {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === filter ? 'bg-[#95c11f] text-white' : 'text-gray-700 hover:bg-gray-200'}`} data-id="element-660">
                  {filter}
                </button>)}
            </div>
          </div>
          {/* Projects */}
          <div ref={projectsRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-661">
            {filteredProjects.map(project => <div key={project.id} className={`transform transition-all duration-700 ${animatedProjects.includes(project.id) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-662">
                <ProjectCard id={project.id} title={project.title} category={project.category} description={project.description} imageUrl={project.imageUrl} data-id="element-663" />
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};
export default Projects;